export default "Conformité OPERAT pour vos immeubles tertiaires ≥ 1 000 m² : trajectoire -40/-50/-60 %, plan d'actions financé par CEE, dépôt 30 septembre sécurisé.";
